import React from "react";
import "./How_product_care_work.css";
import Common_Heading from "../../../common_components/common_Heading/Common_Heading";

function How_product_care_work() {
  return (
    <section className="How_product_care_work">
      <div className="custom_container">
        <div className="desktop_view_holder">
          <div className="row justify-content-center">
            <div className="care_wrapper">
              {/* CENTER IMAGE */}
              <div className="row justify-content-center ">
                <div className="care_circle_img">
                  <img
                    src="/assest/luxury_images/support/peronal_care/how_product_care_work/step_img.png"
                    alt="How product care works"
                    className="step_circle_img"
                  />
                </div>
              </div>

              {/* STEP CONTENT */}
              <div className="step_holder left_step_holer">
                <div className="care_steps step_01 ">
                  <h4>
                    Ask Your <br /> Product Questions
                  </h4>
                  <p>
                    Customers can easily ask about any product like how to use,
                    clean, or maintain it.
                  </p>
                </div>

                <div className="care_steps step_02">
                  <h4>
                    Smart <br /> Assistance
                  </h4>
                  <p>
                    An intelligent system instantly provides accurate &
                    product-specific care instructions.
                  </p>
                </div>

                <div className="care_steps step_03">
                  <h4>
                    Step-by-Step <br /> Guidance
                  </h4>
                  <p>
                    Users receive simple, step-by-step instructions for usage,
                    cleaning, and storage.
                  </p>
                </div>

                <div className="care_steps step_04">
                  <h4>
                    Material-Based <br /> Tips
                  </h4>
                  <p>
                    Responses are personalised based on the product’s material
                    like metal, glass, wood, or fabric.
                  </p>
                </div>
              </div>
              <div className="step_holder right_step_holer">
                <div className="care_steps step_05">
                  <h4>
                    Human Help <br /> Option
                  </h4>
                  <p>
                    If users need more help, they can connect with a care expert
                    or support team for personalised assistance.
                  </p>
                </div>

                <div className="care_steps step_06">
                  <h4>
                    Repair & Warranty <br /> Support
                  </h4>
                  <p>
                    Users can directly get information or links for repair
                    requests, warranty claims, or replacements.
                  </p>
                </div>

                <div className="care_steps step_07">
                  <h4>
                    Do’s <br /> and Don’ts
                  </h4>
                  <p>
                    It highlights precautions to prevent damage what to avoid
                    and what to follow.
                  </p>
                </div>

                <div className="care_steps step_08">
                  <h4>
                    Maintenance <br /> Reminders
                  </h4>
                  <p>
                    The system can remind users when it’s time for routine care
                    or maintenance (optional feature).
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mobile_view_holder">
          <Common_Heading headingText={"How Product Care Work"} />
          <div className="content_box_holder">
            <div className="care_wrapper">
              {/* STEP CONTENT */}
              <div className="step_holder left_step_holer">
                <div className="care_steps step_01 ">
                    <div className="step_number_holder"><h1>1</h1></div>
                  <h4>
                    Ask Your <br /> Product Questions
                  </h4>
                  <p>
                    Customers can easily ask about any product like how to use,
                    clean, or maintain it.
                  </p>
                </div>

                <div className="care_steps step_02">
                    <div className="step_number_holder"><h1>2</h1></div>
                  <h4>
                    Smart <br /> Assistance
                  </h4>
                  <p>
                    An intelligent system instantly provides accurate &
                    product-specific care instructions.
                  </p>
                </div>

                <div className="care_steps step_03">
                    <div className="step_number_holder"><h1>3</h1></div>
                  <h4>
                    Step-by-Step <br /> Guidance
                  </h4>
                  <p>
                    Users receive simple, step-by-step instructions for usage,
                    cleaning, and storage.
                  </p>
                </div>

                <div className="care_steps step_04">
                    <div className="step_number_holder"><h1>4</h1></div>
                  <h4>
                    Material-Based <br /> Tips
                  </h4>
                  <p>
                    Responses are personalised based on the product’s material
                    like metal, glass, wood, or fabric.
                  </p>
                </div>
              </div>
              <div className="step_holder right_step_holer">
                <div className="care_steps step_05">
                <div className="step_number_holder"><h1>5</h1></div>
                  <h4>
                    Human Help <br /> Option
                  </h4>
                  <p>
                    If users need more help, they can connect with a care expert
                    or support team for personalised assistance.
                  </p>
                </div>

                <div className="care_steps step_06">
                    <div className="step_number_holder"><h1>6</h1></div>
                  <h4>
                    Repair & Warranty <br /> Support
                  </h4>
                  <p>
                    Users can directly get information or links for repair
                    requests, warranty claims, or replacements.
                  </p>
                </div>

                <div className="care_steps step_07">
                    <div className="step_number_holder"><h1>7</h1></div>
                  <h4>
                    Do’s <br /> and Don’ts
                  </h4>
                  <p>
                    It highlights precautions to prevent damage what to avoid
                    and what to follow.
                  </p>
                </div>

                <div className="care_steps step_08">
                    <div className="step_number_holder"><h1>8</h1></div>
                  <h4>
                    Maintenance <br /> Reminders
                  </h4>
                  <p>
                    The system can remind users when it’s time for routine care
                    or maintenance (optional feature).
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default How_product_care_work;
